import './index.css'
import './i18n.ts'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ThemeProvider } from 'antd-style'
import Cookies from 'js-cookie'
import { Suspense } from 'react'
import ReactDOM from 'react-dom/client'

import App from './App.tsx'
import { MessageContainer } from './components/index.ts'
import { PageLoading } from './components/PageLoading.tsx'
import ContextProvider from './contexts/index.tsx'

const queryClient = new QueryClient()
const cookie = Cookies.get('cookie')

ReactDOM.createRoot(document.getElementById('root')!).render(
  <ContextProvider cookies={cookie || null}>
    <ThemeProvider
      theme={{
        token: {
          colorPrimary: '#2bcaa5',
          colorBorder: '#99A0AE',
          colorBgContainerDisabled: '#E1E4EA',
        },
      }}
    >
      <Suspense fallback={<PageLoading />}>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
        <MessageContainer />
      </Suspense>
    </ThemeProvider>
  </ContextProvider>,
)
